<template>
  <div class="email-box">
    <label class="chat-widget-container"> </label>
    <div style="text-align: center">
      <input
        v-if="ask_email"
        v-model.trim="email"
        type="email"
        class="email"
        :placeholder="placeholder_email"
        @input="validateEmail"
      />
      <div v-if="emailError" class="error-email">
        {{ emailError }}
      </div>
      <div v-else-if="emailValid" class="valid-email">
        {{ emailValid }}
      </div>
      <div v-else class="holder-email">
        {{ holder_message }}
      </div>
      <textarea
        v-model.trim="text"
        class="box-textarea"
        required
        rows="4"
        :placeholder="placeholder_text"
      >
      </textarea>
      <button
        :disabled="emailError || !text"
        :class="{ disabled: emailError || !text }"
        @click="submit"
      >
        {{ $t('chat.box_email.validate') }}
      </button>
      <button
        v-if="showSkipBtn"
        style="margin: 0 4px 0 4px"
        @click="skipHandler"
      >
        {{ $t('chat.box_email.skip') }}
      </button>
    </div>
  </div>
</template>

<script>
import styleProfile from "@/style-profile";
import utils from "../utils";
import { customLogger } from "@/utils";

const store = require("@/store").default;
export default {
  name: "BoxEmailMessage",
  components: {},
  props: {
    skip_to:{
      type: String,
    },
    ask_email: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      email: "",
      text: "",
      message:
        store.state.user.lang === "en"
          ? "While waiting for an agent to become available ..."
          : "En attendant qu’un agent se libère …",
      placeholder_email:
        store.state.user.lang === "en"
          ? "Enter your email here*"
          : "Entrez votre email ici*",
      placeholder_text:
        store.state.user.lang === "en" 
          ? "Enter your message here*"
          : "Entrez votre message ici*",
      holder_message: "Exemple : email@domaine.com",
      emailError: null,
      emailValid: null,
    };
  },
  computed: {
    lang() {
      const data = store.state.user.lang;
      return data;
    },
    showSkipBtn() {
      // the store allowed to skip the email message
      return store.state.config.chatgpt
    },
  },
  mounted() {
    setTimeout(() => {
      utils.scrollDown();
    }, 250);
  },
  methods: {
    async validateEmail() {
      if (this.email === "") {
        this.emailError = null;
        return;
      }

      await utils
        .checkEmail(this.email)
        .then((data) => {
          this.emailError = null;

          //TODO: add the wording in i18n
          this.emailValid =
            this.lang === "en"
              ? "Your email address is valid"
              : "Votre adresse email est valide";
        })
        .catch(async (err) => {
          await utils.scrollDown();
          this.emailValid = null;
          this.emailError =
            //TODO: add the wording in i18n
            this.lang === "en"
              ? "It seems like the email address is not valid (extension unknown). Could you check your email address please?"
              : "Il semblerait que l'adresse email soit invalide (extension non reconnue). Pourriez-vous revérifier votre adresse email svp ?";
        });
    },
    submit() {
      customLogger("test voir si ça passe bien pas là\n");
      let email = this.email;
      let text = this.text;
      store.state.config.details.zendesk === true
        ? this.$eb.emit("CreateTicketZendesk", {
            chatGpt: this.$store.state.config.chatgpt,
            email,
            textarea: text,
          })
        : this.$eb.emit(
            "BoxEmailMessage",
            {
              chatGpt: this.$store.state.config.chatgpt,
              email,
              textarea: text,
            },
            document.location.href
          );
      if(!this.skip_to){
        store.state.user.style_profile_key = "start";
      }
      this.$store.state.config.chat_config.chat_state.state = "active";
    },
    skipHandler() {
      this.$eb.emit("SkipEmailMessage", this.skip_to || null);
    },
  },
};
</script>
